import { render, staticRenderFns } from "./ProductDescriptionAndKeywords.vue?vue&type=template&id=103235cd&scoped=true&"
import script from "./ProductDescriptionAndKeywords.vue?vue&type=script&lang=js&"
export * from "./ProductDescriptionAndKeywords.vue?vue&type=script&lang=js&"
import style0 from "./ProductDescriptionAndKeywords.vue?vue&type=style&index=0&id=103235cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103235cd",
  null
  
)

export default component.exports